import type { ReactNode } from "react";
import { cn } from "@/lib/cn";

/** Controle segmentado no desenho do SeletorDeDenticao — uma opção ativa por vez. */
export function Segmentado<T extends string>({
  opcoes,
  valor,
  onMudar,
  rotulo,
  className,
}: {
  opcoes: { valor: T; rotulo: ReactNode; titulo?: string }[];
  valor: T;
  onMudar: (v: T) => void;
  rotulo: string;
  className?: string;
}) {
  return (
    <div
      role="radiogroup"
      aria-label={rotulo}
      className={cn("grid rounded-md border border-zinc-200 p-0.5 dark:border-border", className)}
      style={{ gridTemplateColumns: `repeat(${opcoes.length}, minmax(0, 1fr))` }}
    >
      {opcoes.map((o) => {
        const ativo = o.valor === valor;
        return (
          <button
            key={o.valor}
            type="button"
            role="radio"
            aria-checked={ativo}
            title={o.titulo}
            onClick={() => onMudar(o.valor)}
            className={cn(
              "inline-flex items-center justify-center gap-1 rounded px-2 py-1 text-xs font-medium transition-colors",
              ativo ? "bg-brand-50 text-brand-700 dark:bg-primary/10 dark:text-primary" : "text-zinc-500 hover:text-zinc-800 dark:hover:text-foreground",
            )}
          >
            {o.rotulo}
          </button>
        );
      })}
    </div>
  );
}
